<template>
	<el-form-item label="栅格间隔">
		<el-input-number v-model="data.options.gutter" :min="0" />
	</el-form-item>

	<el-form-item label="列项">
		<Draggable item-key="index" ghost-class="ghost" handle=".drag-item" :group="{ name: 'options' }" :list="data.columns">
			<template #item="{ element, index }">
				<div style="margin-bottom: 5px">
					<el-input-number v-model="element.span" placeholder="栅格值" :min="0" :max="24" />
					<span class="drag-item">
						<ma-icon icon="item" color="#666"></ma-icon>
					</span>
					<ma-icon icon="delete" style="cursor: pointer" color="#666" @click="handleOptionsRemove(index)"></ma-icon>
				</div>
			</template>
		</Draggable>
	</el-form-item>

	<el-form-item>
		<el-button type="primary" text link @click="handleInsertColumn"> 添加列项 </el-button>
	</el-form-item>

	<el-form-item label="水平排列方式">
		<el-select v-model="data.options.justify">
			<el-option value="start" label="左对齐" />
			<el-option value="end" label="右对齐" />
			<el-option value="center" label="居中" />
			<el-option value="space-around" label="两侧间隔相等" />
			<el-option value="space-between" label="两端对齐" />
		</el-select>
	</el-form-item>

	<el-form-item label="垂直排列方式">
		<el-select v-model="data.options.align">
			<el-option value="top" label="顶部对齐" />
			<el-option value="middle" label="居中对齐" />
			<el-option value="bottom" label="底部对齐" />
		</el-select>
	</el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import Draggable from 'vuedraggable'

export default defineComponent({
	name: 'ItemGrid',
	components: {
		Draggable
	},
	props: {
		active: {
			type: Object,
			default: null
		}
	},
	emits: ['update:active'],
	setup(props, context) {
		const data = ref(props.active)
		watch(data, val => context.emit('update:active', val), { deep: true })

		const handleInsertColumn = () => {
			data.value.columns?.push({
				span: 12,
				list: []
			})
		}

		const handleOptionsRemove = (index: number) => {
			if (data.value.type === 'grid') {
				data.value.columns?.splice(index, 1)
			} else {
				data.value.options.options.splice(index, 1)
			}
		}
		return {
			data,
			handleInsertColumn,
			handleOptionsRemove
		}
	}
})
</script>
